import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

export const useSelectedConfigTab = (): {
	getSelectedConfigTab: () => string;
	setSelectedConfigTab: (newConfigTab: string) => void;
} => {
	const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';

	const getSelectedConfigTab = (): string =>
		AtlBrowserStorageLocal.getItem(SELECTED_CONFIG_TAB_KEY) || '';

	const setSelectedConfigTab = (newConfigTab: string): void => {
		// @browser-storage setter
		AtlBrowserStorageLocal.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
	};

	return { getSelectedConfigTab, setSelectedConfigTab };
};
